import type {Language} from "~/types/language";
import type {PiniaPluginContext} from "pinia";

const CURRENT_VERSION = "1.0.1";
export const useLanguageStore = defineStore('useLanguageStore', () => {
    const runtimeConfig = useRuntimeConfig()
    const version = ref() // Version persistée
    const languages = ref<Language[] | undefined>([])
    const currentLanguage = ref<Language | undefined>()
    const decathStore = useDecathlonStores()



    watch(
        () => decathStore.selectedCrossDiag,
        (crossDiag) => {
            if (!crossDiag?.languages?.length) return

            currentLanguage.value =
                crossDiag.languages.find(
                    lang => lang.id === currentLanguage.value?.id
                ) ?? crossDiag.languages[0]
        }
    )

    const fetchAllLanguages = async () => {
        languages.value = await useFetchWithToken<Language[]>('fetchAllLanguages', `${runtimeConfig.public.apiBase}/v1/languages`, {
            method: 'get'
        })
        return languages.value
    }

    const findLanguage = (id: string) => languages.value?.find(language => language.id === id) as Language

    const needsMigration = ref(false)

    const checkAndMigrateVersion = () => {
        const persistedVersion = version.value;

        if (persistedVersion !== CURRENT_VERSION) {
            needsMigration.value = true
            // Update version to the current version
            version.value = CURRENT_VERSION
        }
    }

    const migrateIfNeeded = async () => {
        if (needsMigration.value) {
            needsMigration.value = false
            await fetchAllLanguages()
        }
    }

    return {version, currentLanguage, languages, fetchAllLanguages, findLanguage, checkAndMigrateVersion, migrateIfNeeded}
}, {
    persist: {
        pick: ['currentLanguage'],
        afterHydrate: (ctx: PiniaPluginContext) => {
            ctx.store.checkAndMigrateVersion()
            const l = ctx.store.currentLanguage
            if (!l || !/^[a-z]{2}$/i.test(l.id)) {
                ctx.store.currentLanguage = undefined
            }
        }
    }
})
